import { ChangeEvent, useCallback, useState } from 'react';
import { toast } from 'react-toastify';

import { IMAGE_LIMIT_SIZE_10MB, IMAGE_LIMIT_SIZE_3MB } from '@lib/constant';

export const useFileUpload = (limitSize?: number) => {
    const [file, setFile] = useState<File | null>(null);
    const [previewUrl, setPreviewUrl] = useState('');

    const onChangeFile = useCallback(
        (e: ChangeEvent<HTMLInputElement>) => {
            const file = (e.currentTarget.files as FileList)[0];

            if (!file) return;
            if (file.size > (limitSize || IMAGE_LIMIT_SIZE_3MB)) {
                switch (limitSize) {
                    case IMAGE_LIMIT_SIZE_10MB:
                        toast.error('업로드 가능한 용량은 10MB 미만입니다.');
                        break;
                }
                return;
            }
            setFile(file);
            setPreviewUrl(URL.createObjectURL(file));
            e.target.value = '';
        },
        [limitSize]
    );

    const onDeleteFile = useCallback(() => {
        setFile(null);
        setPreviewUrl('');
    }, []);
    return {
        file,
        setFile,
        previewUrl,
        setPreviewUrl,
        onChangeFile,
        onDeleteFile
    };
};
